import { useMutation } from '@tanstack/react-query';
import { authApi } from './auth.api';
import type { ForgotPasswordPayload, ResetPasswordPayload } from '@/types/auth';

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: (payload: ForgotPasswordPayload) => authApi.forgotPassword(payload),
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationFn: (payload: ResetPasswordPayload) => authApi.resetPassword(payload),
  });
};
